// import React from 'react'
// import { Link } from 'react-router-dom'
// import styles from '../../css/about/ourServices.module.css'
// function OurServices() {
//   return (
//     <div className={styles.services}>
//       <div className={styles.servicesCat}>
//         <div>
//           <Link to='/home/all'>الكل</Link>
//         </div>
//         <div>
//           <Link to='/home/companycreated'>تأسيس الشركات</Link>
//         </div>
//         <div >
//           <Link to='/home/supportservices'>الخدمات المساندة</Link>
//         </div>
//         <div >
//           <Link to="/home/premiumresidency">الإقامة المميزة</Link>
//         </div>
//         <div>
//           <Link to='/home/marketingservices'>خدمات التسويق</Link>
//         </div>
//         <div>
//           <Link to='/home/accountingservices'>الخدمات المحاسبة</Link>
//         </div>
//       </div>
//    </div>
//   )
// }

// export default OurServices
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../css/about/ourServices.module.css';

const servicesCategories = [
  { name: 'الكل', path: '/home/all' },
  { name: 'تأسيس الشركات', path: '/home/companycreated' },
  { name: 'الخدمات المساندة', path: '/home/supportservices' },
  { name: 'الإقامة المميزة', path: '/home/premiumresidency' },
  { name: 'خدمات التسويق', path: '/home/marketingservices' },
  { name: 'الخدمات المحاسبة', path: '/home/accountingservices' },
];

function OurServices() {
  return (
    <div className={styles.services}>
      <div className={styles.servicesCat}>
        {servicesCategories.map((service) => (
          <div key={service.path}>
            <Link to={service.path}>{service.name}</Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OurServices;